import React from 'react'
import { Box, TextField, Button, MenuItem } from '@mui/material';

const UserListBox = ({ formik }) => {
  return (
    <Box
      sx={{
        width: '100%',
        px: 1,
      }}
    >
      <Box
        component="form"
        noValidate
        autoComplete="off"
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-end',
          alignItems: 'center',
        }}
        onSubmit={formik.handleSubmit}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-end',
            alignItems: 'center',
            '& > :not(style)': { m: 1, width: '15ch' },
          }}
        >
          <TextField
            variant="standard"
            required
            select
            id="searchKeyword"
            name="searchKeyword"
            label="검색키워드"
            value={formik.values.searchKeyword}
            onChange={formik.handleChange}
            error={
              formik.touched.searchKeyword &&
              Boolean(formik.errors.searchKeyword)
            }
            helperText={
              formik.touched.searchKeyword && formik.errors.searchKeyword
            }
          >
            <MenuItem value="usrNm">이름</MenuItem>
            <MenuItem value="usrNo">사번</MenuItem>
            <MenuItem value="dptNm">부서명</MenuItem>
            <MenuItem value="gradeNm">직급</MenuItem>
          </TextField>
          <TextField
            variant="standard"
            required
            id="searchWords"
            name="searchWords"
            label="검색어"
            value={formik.values.searchWords}
            onChange={formik.handleChange}
            error={
              formik.touched.searchWords && Boolean(formik.errors.searchWords)
            }
            helperText={
              formik.touched.searchWords && formik.errors.searchWords
            }
          />
        </Box>

        <Box>
          <Button
            type="submit"
            color="info"
            variant="contained"
          >
            검색
          </Button>
        </Box>
      </Box>

    </Box>
  )
}

export default UserListBox